import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsLoginState } from './components/IsLoginContext';
import Login from './screens/login/login';

const LandingPage = () => {
    const { isLogin, isInitialized, user } = useIsLoginState();
    const [showLogin, setShowLogin] = useState(false);

    useEffect(() => {
        // 초기화가 완료된 후 처리
        if (isInitialized) {
            if (isLogin && user?.role) {
                // 이미 로그인된 상태라면 역할에 따라 리다이렉트하지 않고 현재 상태 유지
                console.log('이미 로그인된 사용자:', user.role);
            } else {
                // 로그인되지 않은 상태라면 로그인 화면 표시
                setShowLogin(true);
            }
        }
    }, [isInitialized, isLogin, user]);

    // 초기화가 완료되지 않은 경우 로딩 표시
    if (!isInitialized) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column'
            }}>
                <div style={{
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #3498db',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    animation: 'spin 2s linear infinite',
                    marginBottom: '20px'
                }}></div>
                <p>초기화 중...</p>
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        );
    }

    // 로그인된 상태라면 역할에 따라 리다이렉트
    if (isLogin && user?.role) {
        switch (user.role) {
            case 'ADMIN':
                return <Navigate to="/admin" replace />;
            case 'MANAGER':
            case 'MANAGE': // 기존 시스템 호환성을 위해 둘 다 처리
                return <Navigate to="/manager" replace />;
            case 'CHECKER':
                return <Navigate to="/checker" replace />;
            default:
                console.log('알 수 없는 역할:', user.role);
                // 알 수 없는 역할인 경우 로그인 화면 표시
                return <Login />;
        }
    }

    // 로그인되지 않은 상태라면 로그인 화면 표시
    if (showLogin) {
        return <Login />;
    }

    // 기본적으로 로그인 화면 표시
    return <Login />;
};

export default LandingPage;